<template>
  <a :href="href" v-on="$listeners">
    <slot></slot>
  </a>
</template>

<script>
export default {
  props: {
    href: {
      type: String,
      default: '#',
    },
  },
};
</script>

<style scoped lang="scss">
a {
  padding: 20px;
  display: inline-block;
}
.active {
  color: $colour-nhs-core-blue;
}
.inactive {
  color: $colour-nhs-dark-grey;
}
</style>
